import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from '@material-ui/core/Tooltip';
import useStyles from './truncated-text.styles.js';

export const TruncatedText = ({ text, items, className, tooltipPlacement = 'top', maxLength = 29 }) => {
  const classes = useStyles();
  // When a non-empty `items` list is provided, the inline cell shows the comma-joined list and the
  // tooltip renders it as a bullet list (one change per line). Otherwise fall back to plain `text`.
  const inlineText = items?.length ? items.join(', ') : text;
  const shouldTruncate = inlineText && inlineText.length > maxLength;

  if (!shouldTruncate) {
    return <span className={className}>{inlineText}</span>;
  }

  const displayText = `${inlineText.substring(0, maxLength)}...`;
  const tooltipTitle =
    items && items.length > 1 ? (
      <ul className={classes.tooltipList}>
        {items.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>
    ) : (
      inlineText
    );

  return (
    <Tooltip
      title={tooltipTitle}
      label={displayText}
      placement={tooltipPlacement}
      classes={{ tooltip: classes.tooltip }}
      className={`${classes.tooltipLabel} ${className}`}
    >
      <span className={`${classes.truncatedText}`}>{displayText}</span>
    </Tooltip>
  );
};

TruncatedText.propTypes = {
  text: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.string),
  className: PropTypes.string,
  tooltipPlacement: PropTypes.string,
  maxLength: PropTypes.number
};

export default TruncatedText;
